import { NavigationItem } from '@lyceo/homi-dashboard/shared/util-models';
import { Action, ActionReducer, createReducer, on } from '@ngrx/store';
import {
  loadNavigationActions,
  UserActions,
  WalkthroughModalActions,
} from './user.actions';
import { AuthActions } from '@lyceo/shared/auth/data-access';

export const USER_FEATURE_KEY: string = 'user';

export interface UserState {
  navigationItems: NavigationItem[] | [];
  showWalkthrough: boolean;
}

export const initialUserState: UserState = {
  navigationItems: [],
  showWalkthrough: true,
};

const reducer: ActionReducer<UserState, Action> = createReducer(
  initialUserState,
  on(
    AuthActions.logoutSuccess,
    (state): UserState => ({
      ...initialUserState,
      showWalkthrough: state.showWalkthrough,
    }),
  ),
  on(
    loadNavigationActions.loadNavigationItemsSuccess,
    (state, { navigationItems }): UserState => ({
      ...state,
      navigationItems,
    }),
  ),
  on(
    UserActions.walkthroughClicked,
    (state): UserState => ({
      ...state,
      showWalkthrough: true,
    }),
  ),
  on(
    WalkthroughModalActions.modalClosed,
    (state): UserState => ({
      ...state,
      showWalkthrough: false,
    }),
  ),
);

export function userReducer(
  state: UserState | undefined,
  action: Action,
): UserState {
  return reducer(state, action);
}
